import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import SubmissionForm from './SubmissionForm';
import Modal from '../common/Modal/Modal';
import {trackPageView} from '@forwardfinancing/analytics-frontend-library';
import utils from '../../lib/utils';
import linkUtils, { redirectIfAdmin } from '../../lib/linkUtils';
import { SUBMISSION_DISABLED_MESSAGE } from '../../constants/formModalMessages';

class NewSubmissionPage extends React.Component {
  constructor() {
    super();

    this.state = {
      disabled: window.disableSubmissions || false
    };
  }

  componentDidMount() {
    trackPageView(linkUtils.getLocationName(this.props));
    redirectIfAdmin(this.props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isAdmin !== this.props.isAdmin) {
      redirectIfAdmin(this.props);
    }
  }

  render() {
    if (!this.state.disabled) {
      return (
        <div className="new-submission-page column page">
          <SubmissionForm />
        </div>
      );
    } else {
      return (
        <Modal
         desiredClassName="form-completed-message"
         error
         isActive={this.state.disabled}
         onClose={() => redirectIfAdmin(this.props)}
         simpleMessageList={SUBMISSION_DISABLED_MESSAGE}
         withIndicator
        />
      );
    }
  }
}

NewSubmissionPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  isAdmin: PropTypes.bool,
};

NewSubmissionPage.defaultProps = {
  location: {}
};

export default withRouter(connect((state) => {
    return {
      isAdmin: state.user && utils.isAdmin(state.user.role)
    };
  }, {})(NewSubmissionPage)
);
